import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core'
import { Store } from '@ngrx/store'
import { combineLatest, Observable, Subject } from 'rxjs'
import { tap, debounceTime, distinctUntilChanged, takeUntil, withLatestFrom, map } from 'rxjs/operators'

import * as fromClaimStore from '@app/claims/store'
import * as fromCoreStore from '@app/core/store'
import * as fromSidebarStore from '@app/sidebar/store'
import * as fromUserStore from '@app/users/store'
import { Claim } from '@app/claims/models/claim.model'
import { User } from '@app/shared/models/user.model'
import { getUser } from '@app/users/store'
import { ActivatedRoute, Router } from '@angular/router'
import { RedirectService } from '@app/shared'

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-claims',
  template: `
    <div class="">
        <app-claim-list
          [claims]="claims"
          [totalCount]="totalCount$ | async"
          [statuses]="statuses"
          [subStatuses]="subStatuses"
          [stages]="stages"
          [sources]="sources"
          [loading]="loading$ | async"
          [users]="users$ | async"
          [claimFilters]="filters"
        ></app-claim-list>
    </div>
  `,
  styles: [
    `
      .quote-list__container {
        display: flex;
        justify-content: center;
        width: 100%;
      }
    `
  ],
  standalone: false
})
export class ClaimsComponent implements OnInit, OnDestroy {
  claims$: Observable<Claim[]>
  totalCount$: Observable<number>
  users$: Observable<User[]>
  // filters$: Observable<any>

  coreVals
  payments$: Observable<any>
  vehiclesVals$: Observable<any>
  loading$: Observable<any>
  subStatuses = []
  statuses = []
  stages = []
  sources = []
  selectedStatusKey = 'claim-list'
  statusPopoverKey = 'popover'
  currentUser: User
  isLoggedIn
  claims
  filters
  userIndex = '0'
  destroyed$ = new Subject<boolean>()

  constructor(
    private store: Store<fromClaimStore.State>, private redirectService: RedirectService, private cdr: ChangeDetectorRef
  ) { this.userIndex = redirectService.getUrlIndex() }

  ngOnInit() {
    this.users$ = this.store.select(fromSidebarStore.selectAllUsers)
    this.payments$ = this.store.select(fromCoreStore.selectCoreValPayments)
    this.loading$ = this.store.select(fromClaimStore.getClaimsLoading)
    this.claims$ = this.store.select(fromClaimStore.selectAllClaims)

    this.store.select(fromClaimStore.selectAllClaims).pipe(
      takeUntil(this.destroyed$),
      tap(claims => {
        this.claims = claims
      })
    ).subscribe()

    this.totalCount$ = this.store.select(fromClaimStore.selectedTotalCount)
    this.store.select(fromUserStore.getLoggedIn).pipe(
      takeUntil(this.destroyed$),
      tap(loggedIn => {
        this.isLoggedIn = loggedIn
      })
    ).subscribe()

    combineLatest([
      this.store.select(fromClaimStore.selectAllStats),
      this.store.select(fromClaimStore.selectAllSubStats),
      this.store.select(fromCoreStore.selectCoreValClaims)
    ])
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe(([status, subStatus, coreVals]) => {
        // console.log({ status, subStatus, coreVals })
        let statusLocal: any = status || []
        for (let k of this.statuses) {
          k.count = 0
        }
        for (let k of this.subStatuses) {
          k.count = 0
        }
        let subStatusLocal: any = subStatus || []

        let statuses = coreVals?.statuses && Array.isArray(coreVals?.statuses) ? [{ key: 'ALL', name: 'ALL' }, ...coreVals.statuses] : [{ key: 'ALL', name: 'ALL' }]
        let stages = coreVals?.stages && Array.isArray(coreVals?.stages) ? [{ key: 'ALL', name: 'ALL' }, ...coreVals.stages] : [{ key: 'ALL', name: 'ALL' }]
        let subStatuses = coreVals?.subStatuses && Array.isArray(coreVals?.subStatuses) ? [{ key: 'ALL', name: 'ALL' }, ...coreVals.subStatuses] : [{ key: 'ALL', name: 'ALL' }]
        let sources = coreVals?.sources && Array.isArray(coreVals?.sources) ? [{ key: 'ALL', name: 'ALL' }, ...coreVals.sources] : [{ key: 'ALL', name: 'ALL' }]

        for (let val of statusLocal) {
          for (let k of statuses) {
            if (val._id == k.name) {
              k.count = val.count
            }
          }
        }
        for (let val of subStatusLocal) {
          for (let k of subStatuses) {
            if (val._id.replace('_', ' ') == k.name) {
              k.count = val.count
            }
            if (val._id == k.name) {
              k.count = val.count
            }
          }
        }

        this.statuses = statuses
        this.subStatuses = subStatuses
        this.stages = stages
        this.sources = sources

        this.cdr.detectChanges()

      })


    combineLatest([
      this.store.select(fromClaimStore.selectAllFilters),
      this.store.select(fromUserStore.getLoggedIn)
    ])
      .pipe(
        takeUntil(this.destroyed$),
      )
      .subscribe(([filters, loggedIn]) => {
        if (loggedIn && filters) {
          let currentFilter = {}
          currentFilter = filters

          let claimFilters: any = {}
          claimFilters = window.localStorage.getItem(this.userIndex + '_CLAIM_FILTER')
          claimFilters = JSON.parse(claimFilters)
          if (claimFilters) {
            currentFilter = { ...currentFilter, ...claimFilters }
            Object.keys(currentFilter).forEach(key => (currentFilter[key] === "" || currentFilter[key] === null) && delete currentFilter[key])
          }
          if (currentFilter) {
            this.filters = currentFilter
          }
          this.store.dispatch(new fromClaimStore.GetClaims({ filters: this.filters }))
        }
      })
  }

  ngOnDestroy() {
    this.destroyed$.next(true)
    this.destroyed$.complete()
    localStorage.removeItem(this.userIndex + '_CLAIM_FILTER')
  }
}
